<template>
  <div class="global-sidebar laboratory-sidebar h-100">
    <div
      v-show="!toggleMenu"
      class="page__sidebar h-100"
    >
      <div class="sr-side-bar ap-sidebar">
        <div class="ap-sidebar__header">
          <b-row class="py-2 w-100 m-0">
            <b-col
              cols="auto"
              class="d-flex pl-3 pr-0"
            >
              <div class="align-self-center">
                <div>
                  <span
                    class="ap-sidebar__title font-weight--medium m-0"
                  >
                    {{ $t('grid.detail.labName') }}
                  </span>
                </div>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-end pr-2">
              <div
                v-testing="'expand-view'"
                class="icon-wrapper-main white"
              >
                <fa-icon
                  fixed-width
                  :icon="['fal', 'vials']"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <section-checks
          :title="$t('laboratory.sidebar.setup')"
          :sections="sections"
          @sectionChanged="sectionsUpdated()"
        />
        <div class="section-header p-1 text-center main">
          <b-col>{{ $t('laboratory.sidebar.processes') }}</b-col>
        </div>
        <div class="scroll-sidebar">
          <b-nav
            class="top-menu"
            vertical
          >
            <div>
              <div>
                <div class="selector">
                  <div
                    v-if="loadingSidebar"
                    class="empty-state-sidebar is-relative d-flex flex-column text-center p-5 align-items-center"
                  >
                    <vt-loading class="full-loading--sidebar" />
                  </div>
                  <template v-else>
                    <div
                      v-if="!tasks.length"
                      class="empty-state-sidebar d-flex flex-column text-center"
                    >
                      <span class="title no-active-processes my-3">{{ $t('laboratory.tracking.noActiveProcesses') }}</span>
                      <div
                        class="empty-state-sidebar-box"
                        style="opacity: .2"
                      />
                      <div
                        class="empty-state-sidebar-box"
                        style="opacity: .18"
                      />
                      <div
                        class="empty-state-sidebar-box"
                        style="opacity: .16"
                      />
                      <div
                        class="empty-state-sidebar-box"
                        style="opacity: .14"
                      />
                      <div
                        class="empty-state-sidebar-box"
                        style="opacity: .12"
                      />
                    </div>
                    <sub-menu
                      v-if="tasks.length"
                      id="statusMenu"
                      class="lab-submenu"
                      :title="$t('laboratory.sidebar.processes')"
                    >
                      <option-nav
                        v-for="(task, indexTask) in tasks"
                        :key="task.operation"
                        :no-lock="false"
                        :class="{ lineHeight: false}"
                        :store="store"
                        :option="task"
                        :value="selectedOption"
                        class="animate__animated animate__fadeIn animate__faster"
                        :style="{ 'animation-delay': (indexTask) * .025+'s'}"
                        @input="selectOption"
                        @setDefaultOption="setDefaultOption($event)"
                      >
                        <span class="sidebar-item-label">{{ task.label }}</span>
                        <b-badge
                          v-if="summaryTasks && summaryTasks[task.operation]"
                          class="count-badge"
                          variant="vt-red"
                          pill
                        >
                          <span
                            :key="summaryTasks[task.operation]"
                            class="animate__animated animate__fadeIn animate__faster"
                            :style="{ 'animation-delay': (indexTask) * .005+'s'}"
                          >
                            {{ summaryTasks[task.operation] }}
                          </span>
                        </b-badge>
                      </option-nav>
                    </sub-menu>
                  </template>
                </div>
              </div>

              <template v-if="isCytologyChecked">
                <div class="section-header p-2 text-center main">
                  <b-col>{{ $t('laboratory.sidebar.cytologiesProcessed') }}</b-col>
                </div>
                <div class="cytology-sidebar">
                  <div class="selector">
                    <sub-menu
                      id="statusMenu"
                      class="lab-submenu"
                      :title="$t('laboratory.sidebar.processes')"
                    >
                      <!-- TODO: Hay que pasarle a option-nav los parámetros finales para que se quede señalada la sección y poder hacer el lock/unlock-->
                      <option-nav
                        v-for="sidebarItem in cytologySidebar"
                        :key="sidebarItem.index"
                        :class-link="'cytology-links'"
                        :no-lock="false"
                        :class="{lineHeight: false}"
                        :option="sidebarItem"
                        :alticon="'fal ' + sidebarItem.icon"
                        :value="selectedOption"
                        @input="selectOption"
                        @setDefaultOption="setDefaultOption($event)"
                      >
                        <span class="link-label">{{ sidebarItem.label }}</span>
                      </option-nav>
                    </sub-menu>
                  </div>
                </div>
              </template>
            </div>
          </b-nav>
        </div>
        <b-nav
          class="bottom-menu ap-sidebar__footer"
          vertical
        >
          <b-nav-item
            id="expandedSideBarCollapse"
            class="w-100"
            @click="changeSideBarToggle"
          >
            <b-button
              v-testing="'compact'"
              v-shortkey="['f1']"
              class="blank-button"
              @shortkey.prevent="changeSideBarToggle"
            >
              <i
                class="fas fa-chevron-left px-3"
                aria-hidden="true"
              />
            </b-button>
          </b-nav-item>
        </b-nav>
      </div>
    </div>

    <!--Compact menu-->
    <div
      v-show="toggleMenu"
      class="sr-compact-side-bar ap-sidebar--compact laboratory"
    >
      <b-nav
        class="top-menu-compact"
        vertical
      >
        <div
          id="laboratoryTitle"
          v-testing="'compact-view'"
          class="menu-module icon-wrapper"
        >
          <i
            class="nav-icon fal fa-vials"
            aria-hidden="true"
          />
        </div>
        <b-popover
          target="laboratoryTitle"
          container="laboratoryTitle"
          triggers="hover"
          placement="rightbottom"
        >
          <div class="ap-sidebar--compact__pop">
            <div class="ap-sidebar--compact__pop-title d-flex align-items-center">
              <div>{{ $t('grid.detail.labName') }}</div>
            </div>
          </div>
        </b-popover>
        <div class="ap-sidebar--compact__block" />
      </b-nav>
      <b-nav>
        <div class="section-setup-compact">
          <section-checks
            :title="$t('laboratory.sidebar.setup')"
            :sections="sections"
            :is-compact="true"
            :sidebar-state="toggleMenu"
          >
            <b-popover
              triggers="hover"
              target="pop-section-setup"
              placement="rightbottom"
              container="pop-section-setup"
              class="popover-sections"
            >
              <div class="ap-sidebar--compact__pop pop-module">
                <div class="ap-sidebar--compact__pop-title d-flex align-items-center">
                  <div>{{ $t('laboratory.sidebar.setup') }}</div>
                </div>
                <ul
                  class="section-list px-3 m-0"
                  style="list-style:none"
                >
                  <li
                    v-for="(section, indexSection) in sections"
                    :key="section.id"
                    class="py-2"
                  >
                    <b-form-checkbox
                      :id="`compact-${section.id}`"
                      v-model="section.checked"
                      v-testing="section.code"
                      @change="sectionChanged(section, indexSection)"
                    >
                      <span>{{ section.name }}</span>
                    </b-form-checkbox>
                  </li>
                </ul>
              </div>
            </b-popover>
          </section-checks>
        </div>
      </b-nav>
      <div class="selector top-menu">
        <div>
          <b-nav vertical>
            <b-nav-item
              :id="'pop-lab-compact'"
              class="menu-item compact-item"
              style="padding: 1.5px"
            >
              <div class="menu-button">
                <i
                  class="far fa-ellipsis-h"
                  aria-hidden="true"
                />
              </div>
            </b-nav-item>
            <b-popover
              :target="'pop-lab-compact'"
              :container="'pop-lab-compact'"
              triggers="hover"
              placement="rightbottom"
              class="popover-global"
            >
              <div class="menu-popover ap-sidebar--compact__pop">
                <p class="menu-popover-title">
                  {{ $t('laboratory.sidebar.processes') }}
                </p>
                <b-nav class="menu-popover-items">
                  <option-nav
                    v-for="(task, indexTask) in tasks"
                    :key="task.operation"
                    style="position:relative"
                    :class-link="'enlaces-submenu'"
                    :no-lock="false"
                    :class="{lineHeight: false}"
                    class="animate__animated animate__fadeIn animate__faster"
                    :style="{ 'animation-delay': (indexTask) * .025+'s'}"
                    :store="store"
                    :option="task"
                    :value="selectedOption"
                    @input="selectOption"
                    @setDefaultOption="setDefaultOption($event)"
                  >
                    <span class="pl-1 sidebar-item-label">{{ task.label }}</span>
                    <b-badge
                      v-if="summaryTasks && summaryTasks[task.operation]"
                      :class="task.count ? 'count-badge-red' : 'count-badge'"
                      variant="vt-red"
                      pill
                    >
                      <span
                        :key="summaryTasks[task.operation]"
                        class="animate__animated animate__fadeIn animate__faster"
                        :style="{ 'animation-delay': (indexTask) * .005+'s'}"
                      >
                        {{ summaryTasks[task.operation] }}
                      </span>
                    </b-badge>
                  </option-nav>
                </b-nav>
              </div>
            </b-popover>
          </b-nav>
        </div>
      </div>

      <template v-if="isCytologyChecked">
        <div class="ap-sidebar--compact__block" />
        <b-nav
          v-for="sidebarItem in cytologySidebar"
          :key="sidebarItem.index"
          class="cytology-element"
          vertical
        >
          <div
            :id="sidebarItem.icon"
            class="menu-module icon-wrapper"
            @click="selectOption(sidebarItem)"
          >
            <i
              :class="'nav-icon fal ' + sidebarItem.icon"
              aria-hidden="true"
            />
          </div>
          <b-popover
            :target="sidebarItem.icon"
            :container="sidebarItem.icon"
            triggers="hover"
            placement="rightbottom"
          >
            <div class="menu-popover ap-sidebar--compact__pop">
              <div class="menu-popover-title d-flex align-items-center">
                <div>{{ sidebarItem.label }}</div>
              </div>
            </div>
          </b-popover>
        </b-nav>
      </template>

      <b-nav
        class="bottom-menu ap-sidebar--compact__footer compact p-1"
        vertical
      >
        <b-nav-item
          class="menu-item"
          @click="changeSideBarToggle"
        >
          <b-button
            v-testing="'expand'"
            v-shortkey="['f1']"
            class="blank-button"
            @shortkey.prevent="changeSideBarToggle"
          >
            <i
              class="fas fa-chevron-right"
              aria-hidden="true"
            />
          </b-button>
        </b-nav-item>
      </b-nav>
    </div>
  </div>
</template>

<script>
import SectionChecks from './SectionChecks'
import OptionNav from '@/components/sideBar/OptionNav'
import SubMenu from '@/components/sideBar/SubMenu'
import sectionsMixin from '@/modules/laboratoryModule/mixins/sectionsMixin'
import tasksMixin from '@/modules/laboratoryModule/mixins/tasksMixin'
import laboratorySidebarStore from '@/modules/laboratoryModule/sideBar/laboratorySideBarStore'
import { GridUtils } from '@/shared/util/grid-utils'

export default {
    name: 'LaboratorySideBar',
    components: {
        SectionChecks,
        OptionNav,
        SubMenu
    },
    mixins: [
        sectionsMixin,
        tasksMixin
    ],
    data() {
        return {
            gridRouteName: 'laboratoryModule',
            sideBarReset: false,
            toggleMenu: false,
            store: laboratorySidebarStore,
            state: laboratorySidebarStore.state,
            loadingSidebar: true,
            cytologySidebar: [
                {
                    label: this.$t('laboratory.sidebar.today'),
                    id: 'laboratory.processed.today',
                    icon: 'fa-calendar-day',
                    type: 'sample',
                    url: 'searchProcessedSamples',
                    putCall: true,
                    uicomponent: 'uicomponent.laboratory.sample.processed',
                    filterModel: {
                        lastGrossingDate: GridUtils.getTodayDateFilterModel()
                    }
                },
                {
                    label: this.$t('laboratory.sidebar.thisWeek'),
                    id: 'laboratory.processed.thisWeek',
                    icon: 'fa-calendar-week',
                    type: 'sample',
                    url: 'searchProcessedSamples',
                    putCall: true,
                    uicomponent: 'uicomponent.laboratory.sample.processed',
                    filterModel: {
                        lastGrossingDate: GridUtils.getThisWeekDateFilterModel()
                    }
                },
                {
                    label: this.$t('laboratory.sidebar.thisMonth'),
                    id: 'laboratory.processed.thisMonth',
                    icon: 'fa-calendar-alt',
                    type: 'sample',
                    url: 'searchProcessedSamples',
                    putCall: true,
                    uicomponent: 'uicomponent.laboratory.sample.processed',
                    filterModel: {
                        lastGrossingDate: GridUtils.getThisMonthDateFilterModel()
                    }
                }
            ]
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        selectedOption() {
            return this.state.selectedOption
        },
        defaultOption() {
            return this.state.config.defaultOptionId
        },
        isCytologyChecked() {
            return this.sections.some(section => section.checked && section.isCytology)
        }
    },
    async mounted() {
        await this.loadSidebarCustomConfig()
        await this._updateSections()

        if (this.$route.params.sidebarOption) {
            const option = this.store.findOptionById(this.$route.params.sidebarOption)
            this.store.setSelectedOption(option)
        }

        this.loadingSidebar = false
        this.$eventHub.$on('updateTaskCount', this._loadTaskCount)
    },
    beforeDestroy() {
        this.$eventHub.$off('updateTaskCount', this._loadTaskCount)
    },
    methods: {
        changeSideBarToggle() {
            this.toggleMenu = !this.toggleMenu

            this.sideBarReset = true
            this.sectionsUpdated()
        },
        async sectionChanged(section, index) {
            this.$set(this.sections, index, section)

            await this.sectionsUpdated()
        },
        async sectionsUpdated() {
            this.loadingSidebar = true

            await this._updateSections()
            await this.saveSidebarCustomConfig()

            this.loadingSidebar = false
        },
        async _updateSections() {
            const filteredSections = this.sections.filter(section => section.checked).map(section => section.id)
            laboratorySidebarStore.setSectionIds(filteredSections)
            await this._getTasks(filteredSections)

            if (filteredSections.length) {
                await laboratorySidebarStore.loadConfig()
                if (this.defaultOption) {
                    laboratorySidebarStore.selectDefaultOption()
                }
            } else {
                laboratorySidebarStore.setSelectedOption(null)
            }
            this.$forceUpdate()
        },
        async _getTasks(sectionIds) {
            if (this.sideBarReset) {
                this.sideBarReset = false
            } else {
                await Promise.allSettled([
                    this.loadTasks(sectionIds),
                    this.loadSummaryTasks(sectionIds)
                ])
            }
        },
        selectOption(ev) {
            laboratorySidebarStore.setSelectedOption(ev)
            this.$router.push({ name: this.gridRouteName })
        },
        setDefaultOption(ev) {
            laboratorySidebarStore.setDefaultOption(ev)
            laboratorySidebarStore.saveConfig()
        },
        async _loadTaskCount() {
            await this.loadSummaryTasks(laboratorySidebarStore.state.sectionIds)
        }
    }
}
</script>

<style lang="scss">
.laboratory-sidebar .count-badge-red {
    margin-left: auto;
}
.laboratory-sidebar .sidebar-item-label {
    margin: 0.25rem 0.25rem 0.25em 0;
}
.laboratory-sidebar .double-bounce1,
.laboratory-sidebar .double-bounce2 {
  background-color: vt-color(sidebar-parent-icon) !important;
}

.laboratory-sidebar .section-parent-checks .check-parent-compact{
  display: none;
}

.laboratory-sidebar .sr-side-bar .check-popover{
  display: none;
}

.laboratory-sidebar .sr-side-bar .nav-link:not(:last-child) {
  min-height: 37px;
}

.laboratory-sidebar .personal-filters-show .sub-menu-items .nav-link,
.laboratory-sidebar .add-personal-filter-link .nav-link {
    padding-right: .5rem;
    padding-left: .5rem;
    padding-top: .1rem;
    padding-bottom: .1rem;
}

/*--Compact sidebar styles--*/
.sr-compact-side-bar.laboratory .arrow {
  display: none;
}

.sr-compact-side-bar.laboratory .section-checks .blank-button,
.sr-compact-side-bar.laboratory .section-checks .arrow-menu {
  display: none;
}

.sr-compact-side-bar.laboratory .popover {
  border-radius: 0;
  border: 0;
  top: -14px !important;
  left: -1px !important;
  box-shadow: 0 2px 5px 0 #6a6a6a;
}

.sr-compact-side-bar.laboratory .menu-popover-title {
  color: vt-color(sidebar-parent-font);
  height: 40px;
}

.sr-compact-side-bar.laboratory .section-header .col{
  display: none;
}

.sr-compact-side-bar.laboratory .section-parent-checks{
  width: 100%
}

.sr-compact-side-bar.laboratory .check-parent .title{
  display: none !important;
}

.sr-compact-side-bar.laboratory .check-parent{
  height: 42px;
}

.sr-compact-side-bar.laboratory .option-nav-lock{
  padding-right: 0;
}

.sr-compact-side-bar.laboratory .option-nav{
  width: 100%;
}

.sr-compact-side-bar.laboratory .menu-popover .nav-link{
  padding: 0 10px !important;
}

.sr-compact-side-bar.laboratory .menu-item.single-button .count-badge{
  right: 0;
  margin-right: -6px;
  bottom: 2px;
}

.sr-compact-side-bar.laboratory .menu-popover .count-badge {
  position: relative !important;
}

.sr-compact-side-bar.laboratory .option-label {
  display: none;
}

.sr-compact-side-bar.laboratory .personal-link .option-label {
  display: block;
}

.sr-compact-side-bar.laboratory .single-block .badge {
  font-size: 0.7rem !important;
}

.sr-compact-side-bar.laboratory .single-button {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sr-compact-side-bar.laboratory .icon-box {
  margin-right: 0;
}

.sr-compact-side-bar.laboratory .icon-box .icon-wrapper {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.sr-compact-side-bar.laboratory .menu-popover a {
  color: vt-color(sidebar-child-font) !important;
}

.sr-compact-side-bar.laboratory .menu-popover .nav-link:hover {
  background: vt-color(primary);
}

.sr-compact-side-bar.laboratory .menu-popover .nav-link.active {
  justify-content: start !important;
}

.sr-compact-side-bar.laboratory .menu-popover .icon-wrapper.locked {
  display: none !important;
}

.sr-compact-side-bar.laboratory .menu-popover .option-nav:hover .icon-wrapper {
  display: none !important;
}

.sr-compact-side-bar.laboratory .menu-popover .option-nav:hover .icon-wrapper.no-lock {
  display: flex !important;
}

.sr-compact-side-bar.laboratory .add-personal-filter-link .nav-link {
    padding-right: .5rem !important;
    padding-left: .5rem !important;
    padding-top: .1rem !important;
    padding-bottom: .1rem !important;
}

.sr-compact-side-bar.laboratory .single-block {
  position: relative;
}

.sr-compact-side-bar.laboratory .single-block .badge {
  position: absolute;
  bottom: 3px;
  right: 5px;
}

.cytology-element:hover {
  background: vt-color(primary);
  cursor: pointer;
}

.cytology-sidebar .nav-link:hover .icon-box {
  display: block !important;
}

.sr-compact-side-bar.laboratory .compact-item{
  list-style: none !important;
}

.sr-compact-side-bar.laboratory .compact-item i{
  color: vt-color(sidebar-parent-font);
}

.sr-compact-side-bar.laboratory .compact-item .nav-link {
  display: flex;
}

</style>

<style scoped lang="scss">

.laboratory-sidebar .section-list span {
  color: vt-color(sidebar-parent-font);
}

.laboratory-sidebar .no-active-processes {
  color: vt-color(sidebar-parent-font);
}

.laboratory-sidebar .add-personal-filter-link div {
  width: 32px;
  height: 32px;
  margin-right: 7px;
}

.laboratory-sidebar .blank-button{
  padding: 0;
  margin: 0;
  background: transparent;
  border: transparent;
  font-size: font-size(small);
}

.laboratory-sidebar .add-personal-filter-link{
  list-style: none;
}

.laboratory-sidebar .add-personal-filter-link:hover {
  background: vt-color(primary);
}

.laboratory-sidebar  .submenu-links {
  .nav-link {
    padding-left:4rem;
  }
}

.laboratory-sidebar  .nav-item.option-nav{
  font-size: 0.9rem;
}

.laboratory-sidebar  .count-badge{
  font-size:0.7rem !important;
  text-align:right;
}

.laboratory-sidebar .section-header{
  text-transform: uppercase;
  font-size:0.9rem;
  background: vt-color(sidebar-section-header-bg);
  color: vt-color(sidebar-section-header-text);
}

.laboratory-sidebar .menu-main-title h4{
  font-size:1.1rem;
  font-weight: normal;
}

.laboratory-sidebar .menu-main-title small{
  font-size:0.7rem;
  text-transform: uppercase;
}

.laboratory-sidebar .menu-main-title{
  line-height: 0.9rem;
}

.laboratory-sidebar .menu-module {
  display: flex;
  align-items: center;
}

.laboratory-sidebar .section-pd{
  width:100%;
  margin:0;
}

.laboratory-sidebar .icon-wrapper-main{
  font-size:1.6rem;
}

.laboratory-sidebar .selector:hover{
  background: vt-color(sidebar-single-element-hover);
}

.laboratory-sidebar .icon-wrapper {
  font-size: 1rem;
  margin-right: 7px;
  width: 32px;
  color: vt-color(sidebar-parent-icon);
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  > .svg-inline--fa {
    margin-left: unset !important;
  }
}

.laboratory-sidebar .link-label{
  margin-right: auto;
}

.laboratory-sidebar .sr-side-bar {
  display: flex;
  flex-direction: column;
  width: 240px;
  height: 100%;
  min-height: 0;
  ::v-deep .nav-link {
    box-sizing: border-box;
    display: flex;
    padding-right: .2rem;
    align-items: center;
    color: $base-text-color;
    color: vt-color(sidebar-child-font) !important;
    font-weight:normal;
  }
}

.laboratory-sidebar .top-menu {
  flex: 0 0 auto;
    ::v-deep .nav-link {
    padding: {
      right: .7rem;
      left: .5rem;
      top: .15rem;
      bottom: .15rem;
    }
    &.active {
      color: vt-color(white-light) !important;
      background-color: vt-color(sidebar-element-actived) !important;
    }
    &:hover {
      color: vt-color(primary);
    }
  }
}

.laboratory-sidebar .add-personal-filter-link {
  font-size: font-size(tiny);
  .secondary-button {
    color: vt-color(primary) !important;
    &:hover {
      color: vt-color(dark-primary) !important;
      text-decoration-line: none !important;
    }
  }
}

.laboratory-sidebar .bottom-menu {
  flex: 0 0 auto;
  background: vt-color(sidebar-bottom-menu-bg);
  height: 31px;
}

.laboratory-sidebar .scroll-sidebar {
  overflow-y: auto;
  flex-grow: 1;
}

.laboratory-sidebar .bottom-menu:hover{
  background: vt-color(sidebar-bottom-menu-hover);
}

.laboratory-sidebar .bottom-menu .blank-button {
  font-size: 1rem;
  background: transparent !important;
}

.laboratory-sidebar .count-badge {
  margin-left: auto;
}

.laboratory-sidebar .menu-list {
  flex-grow: 1;
  padding: {
  }
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
    &:hover {
      background-color: #aaa;
    }
  }
}

/*--Compact sidebar styles--*/
.sr-compact-side-bar.laboratory .bottom-menu.compact {
  flex: 0 0 auto;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.sr-compact-side-bar.laboratory .section-list {
  background: vt-color(sidebar-childs-bg);
}

.sr-compact-side-bar{
  position:relative;
}

.sr-compact-side-bar.laboratory .add-personal-filter-link div {
  width: 32px;
  height: 32px;
  margin-right: 7px;
}

.sr-compact-side-bar.laboratory .blank-button{
  padding: 0;
  margin: 0;
  background: transparent;
  border: transparent;
}

.sr-compact-side-bar.laboratory .filter-button {
  color: vt-color(white-light) !important;
}

.sr-compact-side-bar.laboratory .pop-module-layout{
  margin-left: 1.3rem;
  min-height: 35px;
}

.sr-compact-side-bar.laboratory .pop-module-layout small{
  text-transform: uppercase;
}

.sr-compact-side-bar.laboratory .option-label-compact{
  height:10px;
  width: 100%;
  background: vt-color(sidebar-section-header-bg);
}

.sr-compact-side-bar.laboratory .pop-section .menu-popover-title{
  font-size: .8rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  color: vt-color(primary) !important;
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}

$sideBarBorder: 1px solid #d8d8d8;

.sr-compact-side-bar.laboratory{
  padding-top: 0 !important;
  width: 3.7rem !important;
}

.sr-compact-side-bar.laboratory .nav-link{
  padding: 0 !important;
}

.sr-compact-side-bar.laboratory .menu-module{
  margin: 0 !important;
  width:100% !important;
  color: vt-color(white-light) !important;
}

.sr-compact-side-bar.laboratory .nav-item.option-nav.menu-item:hover{
  background: vt-color(primary);
}

.sr-compact-side-bar.laboratory .icon-wrapper {
  font-size: 1.2rem;
  margin: auto;
  width: 32px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: vt-color(primary);
}

.sr-compact-side-bar.laboratory {
  display: flex;
  flex-direction: column;
  width: 63px;
  height: 100%;
  padding-top: 16px;
  .menu-item {
    position: relative;
    text-align: center;
      ::v-deep .nav-link {
      color: $base-text-color;
      &:hover {
        color: $header-text-color;
      }
    }
  }
}

.sr-compact-side-bar.laboratory .top-menu {
  .menu-item {
    font-size: 19px;
  }
}

.sr-compact-side-bar.laboratory .top-menu ::v-deep .nav-link.active {
  color: $header-text-color;
  background: vt-color(primary);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sr-compact-side-bar.laboratory .middle-menu {
  flex-grow: 1;
  padding-bottom: 1rem;
  .menu-item {
    font-size: 19px;
  }
}

.sr-compact-side-bar.laboratory .bottom-menu {
  flex: 0 0 auto;
  height: 31px;
}

.sr-compact-side-bar.laboratory .icon-collapse{
  margin-top:5px;
}

.sr-compact-side-bar.laboratory .bottom-menu .blank-button {
  font-size: 1rem;
  background: transparent !important;
}

.sr-compact-side-bar.laboratory .menu-button {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: vt-color(primary);
  font-size: 1.2rem;
}

.sr-compact-side-bar.laboratory .menu-button.parent-button{
  color: vt-color(sidebar-parent-font);
}

.sr-compact-side-bar.laboratory .menu-button:hover{
  background: vt-color(sidebar-parent-bg-hover);
}

.sr-compact-side-bar.laboratory .menu-popover {
  width: 280px;
  font-size: .9rem;
  .menu-popover-title {
    margin-bottom: 0;
    padding-left: 1.3rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .menu-popover-items {
    font-size: 0.9rem;
    background: vt-color(sidebar-childs-bg);
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    overflow-x: hidden;
    color: #303133;
      ::v-deep .nav-link {
      display: flex;
      align-items: center;
      padding-left: 0;
      padding-top: 0;
      padding-bottom: 0;
      &.active {
        color: $header-text-color;
      }
    }
  }
}

@media (max-width: 1300px){
  .laboratory-sidebar .count-badge{
    font-size:0.7rem !important;
  }

  .laboratory-sidebar .link-label{
    font-size: 0.9rem;
  }

  .laboratory-sidebar .icon-wrapper{
    font-size: 1.1rem;
  }
  .laboratory-sidebar .section-header{
    font-size:0.8rem;
  }

  .laboratory-sidebar .menu-main-title h4{
    font-size:1rem;
  }

  .laboratory-sidebar .menu-main-title small{
    font-size:0.65rem;
  }

  .laboratory-sidebar .menu-main-title{
    line-height: 0.9rem;
  }

  .laboratory-sidebar .icon-wrapper-main{
  font-size:1.4rem;
}

  .laboratory-sidebar .nav-item.option-nav{
    font-size: 0.9rem;
  }

  /*-- Compact sidebar styles --*/
  .icon-wrapper {
    font-size: 1.1rem;
  }

  .menu-button {
    font-size: 1rem;
  }
}

</style>
